import { flow, fromPairs, map } from 'lodash/fp';

export default flow(
  map(({ label, value }) => [value, label]),
  fromPairs,
);
